// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dg89","col":"styles_col__3ufvC"};